import { render, staticRenderFns } from "./reports.view.component.vue?vue&type=template&id=2d27b3d4&scoped=true&"
import script from "./reports.view.component.vue?vue&type=script&lang=js&"
export * from "./reports.view.component.vue?vue&type=script&lang=js&"
import style0 from "./reports.view.component.vue?vue&type=style&index=0&id=2d27b3d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27b3d4",
  null
  
)

export default component.exports